// components/organism/SphereEditor/FormikDebugger.tsx

import React from 'react';
import { useFormikContext } from 'formik';

const FormikDebugger: React.FC = () => {
  const { values, errors, touched, isSubmitting } = useFormikContext<any>();

  React.useEffect(() => {
    console.log("Formik Values:", values);
  }, [values]);

  React.useEffect(() => {
    console.log("Formik Errors:", errors);
  }, [errors]);

  React.useEffect(() => {
    console.log("Formik Touched Fields:", touched);
  }, [touched]);

  React.useEffect(() => {
    console.log("Formik isSubmitting:", isSubmitting);
  }, [isSubmitting]);

  return null; // This component doesn't render anything
};

export default FormikDebugger;
